import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { t, T } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import Typography from '@material-ui/core/Typography';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

const createColorsGradient = (...colors) => {
  const percent = 100 / colors.length;
  return `linear-gradient(90deg, ${colors
    .map((color, idx) => `${color} ${idx * percent}%, ${color} ${(idx + 1) * percent}%`)
    .join(', ')})`;
};

const useStyles = makeStyles((theme) => ({
  root: {
    '&:before': {
      display: 'flex',
      content: '""',
      height: 3,
      background: createColorsGradient('#888', '#385dad', '#fedb03', '#00ab84', '#eb0045'),
      flex: 1,
      flexBasis: '100%',
      marginBottom: '0.5rem',
      [theme.breakpoints.up('sm')]: {
        marginBottom: '1rem',
        height: 7,
      },
    },
    ...theme.typography.body1,
    background: 'black',
    color: 'white',
    display: 'flex',
    flexWrap: 'wrap',
    padding: '0.5rem',
    fontSize: '0.6rem',
    paddingLeft: 'calc(1rem + 24px)', // space for cookie consent settings button
    [theme.breakpoints.up('sm')]: {
      padding: '1rem',
      fontSize: '1rem',
      paddingLeft: 'calc(2rem + 48px)', // space for cookie consent settings button
    },
  },
  companyLabel: {
    color: 'white',
  },
  links: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
    gap: '0.5rem',
    [theme.breakpoints.up('sm')]: {
      gap: '2rem',
    },
    '& > a': {
      color: 'white',
      textDecoration: 'none',
      display: 'inline-flex',
      gap: '0.2rem',
      '& > svg': {
        fontSize: '0.8rem',
        [theme.breakpoints.up('sm')]: {
          fontSize: '1.5rem',
        },
      },
      '& > span': {
        transition: 'transform ease 0.1s',
      },
      '&:hover > span': {
        transform: 'translate(0.2rem)',
      },
    },
  },
}));

export const Footer = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography className={classes.companyLabel}>{T('footer.companyName')}</Typography>
      <div className={classes.links}>
        {['imprint', 'dataPrivacy'].map((key) => (
          <a key={key} href={t(`footer.links.${key}.link`)} target="_blank" rel="noreferrer">
            <ChevronRightIcon />
            <span>{t(`footer.links.${key}.label`)}</span>
          </a>
        ))}
      </div>
    </div>
  );
};
